import { css } from '@emotion/react';

export default css({
  '.new-user-nav-bar': {
    '&__sign-out-btn': {
      padding: 0,
    },
  },
});
